import { AnyAction } from 'redux';
import { LOGOUT_SUCCESS, VERIFY_LOGIN_OTP_SUCCESS } from '../types/auth';
import { CREATE_APPLICATION_SUCCESS } from '../types/application';
import { USER_ROLES } from '../../utils/constant';

export type ParamsProps = {
  page: number;
  search: string;
  applicationType: string;
  status: string;
  modeOfHolding: string;
  distributorId: string;
  applicationSentBack: boolean | null;
  schemeId: string;
};

export const initialState: ParamsProps = {
  page: 1,
  applicationType: '',
  status: '',
  search: '',
  modeOfHolding: '',
  distributorId: '',
  applicationSentBack: null,
  schemeId: '',
};

function paramsReducer(state = initialState, action: AnyAction): Partial<ParamsProps> {
  switch (action.type) {
    case VERIFY_LOGIN_OTP_SUCCESS: {
      return {
        ...state,
        status:
          action.body.role === USER_ROLES.AMCAPPROVER
            ? 'sent_to_amc_approver'
            : action.body.role === USER_ROLES.POAAPPROVER
            ? 'sent_to_poa_approver'
            : action.body.role === USER_ROLES.RTAAPPROVER
            ? 'sent_to_rta_approver'
            : action.body.role === USER_ROLES.FUND_MANAGER
            ? 'approved_by_authorised_signatories,approved_by_applicants,approved_by_applicant1,approved_by_applicant2,approved_by_applicant3'
            : action.body.role === USER_ROLES.TRUSTEE
            ? 'approved_by_fundmanager'
            : '',
      };
    }
    case 'GET_PARAMS_DATA':
      return {
        ...state,
        page: action.paramsObj.page,
        applicationType: action.paramsObj.applicationType,
        status: action.paramsObj.status,
        modeOfHolding: action.paramsObj.modeOfHolding,
        distributorId: action.paramsObj.distributorId,
        search: action.paramsObj.search,
        applicationSentBack: action.paramsObj.applicationSentBack,
        schemeId: action.paramsObj.schemeId,
      };
    case CREATE_APPLICATION_SUCCESS:
    case LOGOUT_SUCCESS: {
      return { ...initialState };
    }
    default:
      return state;
  }
}

export default paramsReducer;
